<template>
	<div class="row">
		<div class="col-lg-3">
			<form @submit.prevent>
				<div class="container p-0 my-2">
					 <div class="form-group mb-1">
						<div>
							<multiselect v-model="filtered.make" :options="makes" label="name" track-by="name" :custom-label="customLabel" :show-labels="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Manufacturer" :preselect-first="false" @input="clearSelected($event, 'make')">
								<template slot="option" slot-scope="props">
      								<div><span class="item">{{ props.option.name }}</span> <span class="number">({{ props.option.number }})</span></div>
    							</template>
							</multiselect>
						</div>
					</div>
					<div class="form-group mb-1">
						<div class="m-2">
							<vue-slider v-model="years" :min="1980" :max="new Date().getFullYear()" :enable-cross="false" @change="clearSelected($event, 'years')" :tooltip="'active'"></vue-slider>
						</div>
					</div>
					<div class="form-group mb-1">
						<div>
							<multiselect v-model="filtered.engcylinders" :options="cylinders" label="name" track-by="name" :custom-label="customLabel" :show-labels="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Cylinder Qty" :preselect-first="false" @input="clearSelected($event, 'engcylinders')">
								<template slot="option" slot-scope="props">
      								<div><span class="item">{{ props.option.name }}</span> <span class="number">({{ props.option.number }})</span></div>
    							</template>
							</multiselect>
						</div>
					</div>
					<div class="form-group mb-1">
						<div>
							<multiselect v-model="filtered.enggearqty" :options="gears" label="name" track-by="name" :custom-label="customLabel" :show-labels="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Gear Qty" :preselect-first="false" @input="clearSelected($event, 'enggearqty')">
								<template slot="option" slot-scope="props">
      								<div><span class="item">{{ props.option.name }}</span> <span class="number">({{ props.option.number }})</span></div>
    							</template>
							</multiselect>
						</div>
					</div>
					<div class="form-group mb-1">
						<div>
							<multiselect v-model="filtered.wheeldiafrt" :options="frontDiameter" label="name" track-by="name" :custom-label="customLabel" :show-labels="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Front Wheel Size" :preselect-first="false" @input="clearSelected($event, 'wheeldiafrt')">
								<template slot="option" slot-scope="props">
      								<div><span class="item">{{ props.option.name }}</span> <span class="number">({{ props.option.number }})</span></div>
    							</template>
							</multiselect>
						</div>
					</div>
					<div class="form-group mb-1">
						<div>
							<multiselect v-model="filtered.wheeldiarear" :options="rearDiameter" label="name" track-by="name" :custom-label="customLabel" :show-labels="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Rear Wheel Size" :preselect-first="false" @input="clearSelected($event, 'wheeldiarear')">
								<template slot="option" slot-scope="props">
      								<div><span class="item">{{ props.option.name }}</span> <span class="number">({{ props.option.number }})</span></div>
    							</template>
							</multiselect>
						</div>
					</div>
					<div class="form-group mb-1">
						<div>
							<multiselect v-model="filtered.wheeltype" :options="wheelType" label="name" track-by="name" :custom-label="customLabel" :show-labels="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Wheel Constuction" :preselect-first="false" @input="clearSelected($event, 'wheeltype')">
								<template slot="option" slot-scope="props">
      								<div><span class="item">{{ props.option.name }}</span> <span class="number">({{ props.option.number }})</span></div>
    							</template>
							</multiselect>
						</div>
					</div>
					<div class="form-group mb-1">
						<div>
							<multiselect v-model="filtered.finaldrive" :options="finalDrive" label="name" track-by="name" :custom-label="customLabel" :show-labels="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Final Drive" :preselect-first="false" @input="clearSelected($event, 'finaldrive')">
								<template slot="option" slot-scope="props">
      								<div><span class="item">{{ props.option.name }}</span> <span class="number">({{ props.option.number }})</span></div>
    							</template>
							</multiselect>
						</div>
					</div>
					<div class="form-group mb-1">
						<div>
							<multiselect v-model="filtered.bikeabs" :options="abs" label="name" track-by="name" :custom-label="customLabel" :show-labels="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="ABS" :preselect-first="false" @input="clearSelected($event, 'bikeabs')">
								<template slot="option" slot-scope="props">
      								<div><span class="item">{{ props.option.name }}</span> <span class="number">({{ props.option.number }})</span></div>
    							</template>
							</multiselect>
						</div>
					</div>
					<div class="form-group mb-1">
						<div>
							<multiselect v-model="filtered.biketc" :options="tractionControl"  label="name" track-by="name" :custom-label="customLabel" :show-labels="false" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Traction Control" :preselect-first="false" @input="clearSelected($event, 'biketc')">
								<template slot="option" slot-scope="props">
      								<div><span class="item">{{ props.option.name }}</span> <span class="number">({{ props.option.number }})</span></div>
    							</template>
							</multiselect>
						</div>
					</div>
					<div class="form-group mb-1">
						<div>
							<multiselect v-model="filtered.engfueling" :options="fuelDelivery" label="name" track-by="name" :custom-label="customLabel" :show-labels="false"  :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Fuel Delivery" :preselect-first="false" @input="clearSelected($event, 'engfueling')">
								<template slot="option" slot-scope="props">
      								<div><span class="item">{{ props.option.name }}</span> <span class="number">({{ props.option.number }})</span></div>
    							</template>
							</multiselect>
						</div>
					</div>
				</div>
				<div class="container bg-light border border-light rounded p-2">
					<div for="riderWeight" class="form-group mb-1">
						<div class="input-group" v-if="unit === 'metric'">
							<input-formatted placeholder="Rider weight" name="rider" v-model="inputs.rider.metric"></input-formatted>
							<div class="input-group-append">
								<div class="input-group-text">kg</div>
							</div>
						</div>
						<div class="input-group" v-else>
							<input-formatted placeholder="Rider weight" name="rider" v-model="inputs.rider.us"></input-formatted>
							<div class="input-group-append">
								<div class="input-group-text">lb</div>
							</div>
						</div>
					</div>
					<div for="gearWeight" class="form-group mb-1">
						<div class="input-group" v-if="unit === 'metric'">
							<input-formatted placeholder="Gear weight" name="gear" v-model="inputs.gear.metric"></input-formatted>
							<div class="input-group-append">
								<div class="input-group-text">kg</div>
							</div>
						</div>
						<div class="input-group" v-else>
							<input-formatted placeholder="Gear weight" name="gear" v-model="inputs.gear.us"></input-formatted>
							<div class="input-group-append">
								<div class="input-group-text">lb</div>
							</div>
						</div>
					</div>
					<div for="luggageWeight" class="form-group mb-1">
						<div class="input-group" v-if="unit === 'metric'">
							<input-formatted placeholder="Luggage weight" name="luggage" v-model="inputs.luggage.metric"></input-formatted>
							<div class="input-group-append">
								<div class="input-group-text">kg</div>
							</div>
						</div>
						<div class="input-group" v-else>
							<input-formatted placeholder="Luggage weight" name="luggage" v-model="inputs.luggage.us"></input-formatted>
							<div class="input-group-append">
								<div class="input-group-text">lb</div>
							</div>
						</div>
					</div>
					<div for="farklesWeight" class="form-group mb-1">
						<div class="input-group" v-if="unit === 'metric'">
							<input-formatted placeholder="Farkles weight" name="farkles" v-model="inputs.farkles.metric"></input-formatted>
							<div class="input-group-append">
								<div class="input-group-text">kg</div>
							</div>
						</div>
						<div class="input-group" v-else>
							<input-formatted placeholder="Farkles weight" name="farkles" v-model="inputs.farkles.us"></input-formatted>
							<div class="input-group-append">
								<div class="input-group-text">lb</div>
							</div>
						</div>
					</div>
					<div for="farklesWeight" class="form-group mb-1">
						<div class="input-group" v-if="unit === 'metric'">
							<input-formatted placeholder="Target range" name="target" v-model="inputs.target.metric"></input-formatted>
							<div class="input-group-append">
								<div class="input-group-text">km</div>
							</div>
						</div>

						<div class="input-group" v-else>
							<input-formatted placeholder="Target range" name="target" v-model="inputs.target.us"></input-formatted>
							<div class="input-group-append">
								<div class="input-group-text">mi</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="col-lg-9">
			<div v-if="matches.length > 0">
				<form @submit.prevent>
					<div class="alert alert-danger pb-0" role="alert"  v-if="error.length > 0">
						<p>{{ error }}</p>
					</div>
					<div class="table-responsive">
						<table class="form-check table table-striped px-0">
							<thead class="thead-light small">
								<tr>
									<th scope="col"></th>
									<th scope="col" class="align-middle text-nowrap">
										<a href="javascript:void(0)" @click="sortBy('make')" :class="{'active': sortKey == 'make'}">
											<span>Manufacturer&nbsp;</span>
											<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="7.5" height="12" viewBox="0 0 320 512">
												<path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z" />
											</svg>
										</a>
									</th>
									<th scope="col" class="align-middle text-nowrap">
										<a href="javascript:void(0)" @click="sortBy('model')" :class="{'active': sortKey == 'model'}">
											<span>Model&nbsp;</span>
											<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="7.5" height="12" viewBox="0 0 320 512">
												<path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z" />
											</svg>
										</a>
									</th>
									<th scope="col" class="align-middle">
										<a href="javascript:void(0)" @click="sortBy('startyr')" :class="{'active': sortKey == 'startyr'}">
											<span>First Production Year&nbsp;</span>
											<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="7.5" height="12" viewBox="0 0 320 512">
												<path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z" />
											</svg>
										</a>
									</th>
									<th scope="col" class="align-middle">
										<a href="javascript:void(0)" @click="sortBy('endyr')" :class="{'active': sortKey == 'endyr'}">
											<span>Last Production Year&nbsp;</span>
											<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="7.5" height="12" viewBox="0 0 320 512">
												<path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z" />
											</svg>
										</a>
									</th>
									<th scope="col" class="align-middle">
										<a href="javascript:void(0)" @click="sortBy('wetweightcalc')" :class="{'active': sortKey == 'wetweightcalc'}">
											<span>Wet Weight&nbsp;</span>
											<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="7.5" height="12" viewBox="0 0 320 512">
												<path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z" />
											</svg>
										</a>
									</th>
									<th scope="col" class="align-middle">
										<a href="javascript:void(0)" @click="sortBy('powertoweight')" :class="{'active': sortKey == 'powertoweight'}">
											<span>Power/Weight Ratio&nbsp;</span>
											<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="7.5" height="12" viewBox="0 0 320 512">
												<path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z" />
											</svg>
										</a>
									</th>
									<th scope="col" class="align-middle">
										<a href="javascript:void(0)" @click="sortBy('fullbikeweight')" :class="{'active': sortKey == 'fullbikeweight'}">
											<span>Full Bike Weight inc. Extra Fuel & Luggage&nbsp;</span>
											<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="7.5" height="12" viewBox="0 0 320 512">
												<path fill="currentColor" d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z" />
											</svg>
										</a>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="match in sortedData">
									<td>
										<input class="form-check-input ml-0" :disabled="compareBikes.length > 3  && !selected.includes(match.bikeid)" type="checkbox" :id="match.bikeid" :value="match" v-model="compareBikes" />
									</td>
									<td>
										<label :for="match.bikeid" class="d-block"><span>{{ match.make }}</span></label>
									</td>
									<td>
										<label :for="match.bikeid" class="d-block"><span>{{ match.model }}</span></label>
									</td>
									<td>
										<label :for="match.bikeid" class="d-block"><span>{{ match.startyr }}</span></label>
									</td>
									<td>
										<label :for="match.bikeid" class="d-block"><span v-if="match.endyr === '9999'">In production</span><span v-else>{{ match.endyr }}</span></label>
									</td>

									<td>
										<label :for="match.bikeid" class="d-block">
											<span :class="{ 'text-warning': match.bikewtwet[unit] == 0 }">{{ match.wetweightcalc[unit].toFixed(0) }} {{ match.wetweightcalc.measurement[unit] }}</span>
										</label>
									</td>
									<td>
										<label :for="match.bikeid" class="d-block">
											<span :class="{ 'text-warning': match.bikewtwet[unit] == 0 }">{{ match.powertoweight[unit].toFixed(3) }} {{ match.powertoweight.measurement[unit] }}</span>
										</label>
									</td>
									<td>
										<label :for="match.bikeid" class="d-block">
											<span>{{ match.fullbikeweight[unit].toFixed(0) }} {{ match.fullbikeweight.measurement[unit] }}</span>
										</label>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</form>
			</div>
			<p v-else>No results</p>
		</div>
		
	</div>
	
</template>
<script>
	import Multiselect from "vue-multiselect";
	import VueSlider from "vue-slider-component";
	import EventBus from '../eventbus';
	import "vue-slider-component/theme/antd.css";

	// Components
	import Inputs from "./Inputs.vue";
	import {mapGetters} from 'vuex';


	export default {
		name: "Homepage",
		components: {
			Multiselect,
			VueSlider,
			"input-formatted": Inputs,
		},
		data() {
			return {   
				resultsList: [], 
				filters: ["make", "engcylinders", "enggearqty", "wheeldiafrt", "wheeldiarear", "wheeltype", "bikeabs", "biketc", "engfueling", "finaldrive", "startyr"],
				filtered: {},
				compareBikes: [],
				results: [],
				years: [1980, new Date().getFullYear()],
				error: '',
				selectedList: '',
				// table sorting
				sortKey: "make",
				sort: "asc",
				sortAsc: true,
			};
		},
		methods: {
			getFilters(name) {
				const resultList = this.data;
				let result = {};
				

				let masterList = resultList.map(key => {
					if (typeof key[name] == "string") {
						return key[name];
					}
				});

				let filteredList = this.matches.map(key => {
					if (typeof key[name] == "string") {
						return key[name];
					}
				})

				// get number dropdowns selected.
				const dropdownsSelected = () => {
					let selected = [];
					if(!Object.keys(this.filtered).length) {
						return false
					} 
					let arr = Object.keys(this.filtered)
					for(let item of arr) {
						if(this.filtered[item].length > 0) {
							selected.push(item);	
						} 
					}

					return (selected.length > 0) ? selected : false;
				}

				// determine where to pull the list numbers from the master list
				
				if (!dropdownsSelected()) {
					for (let i = 0; i < masterList.length; i++) {
			  			result[masterList[i]] = (result[masterList[i]] || 0) + 1
					}
				} 

				// if there is one drop down selected and the user is adding to dropdowns that already have items selected
				if(dropdownsSelected().length > 0 && dropdownsSelected().includes(name)) {
					for (let i = 0; i < masterList.length; i++) {
			  			result[masterList[i]] = (result[masterList[i]] || 0) + 1
					}
				}

				// when there is more than one drop down populated items come from master and numbers are based on filtered list
				if(dropdownsSelected().length > 1 || dropdownsSelected()[0] != name) {
					for (let i = 0; i < masterList.length; i++) {
						result[masterList[i]] = (filteredList.filter(x => x == masterList[i]).length || 0)
					}
				}

				return Object.entries(result).map(([key, value]) => {
					return { name: key, number: value}
				})
			},
			clearSelected(e, list) {
				this.selectedList = list;
				this.compareBikes = [];
			},
			sortBy(newValue) {
				this.sortAsc = this.sortKey === newValue ? !this.sortAsc : this.sortAsc;
				this.sortKey = newValue;
			},
			customLabel ({ name, number }) {
	      		return `${name}`
	    	}
		},
		computed: {
            ...mapGetters({
                data: 'BikeDataStore/getResults',
                inputs: 'BikeDataStore/getInputs',
                unit: 'BikeDataStore/getMeasurement'
            }),
			makes() {
				return this.getFilters("make");
			},
			cylinders() {
				return this.getFilters("engcylinders");
			},
			gears() {
				return this.getFilters("enggearqty");
			},
			frontDiameter() {
				return this.getFilters("wheeldiafrt");
			},
			rearDiameter() {
				return this.getFilters("wheeldiarear");
			},
			wheelType() {
				return this.getFilters("wheeltype");
			},
			abs() {
				return this.getFilters("bikeabs");
			},
			tractionControl() {
				return this.getFilters("biketc");
			},
			fuelDelivery() {
				return this.getFilters("engfueling");
			},
			finalDrive() {
				return this.getFilters("finaldrive");
			},
			selected() {
				return this.compareBikes.map(item => item.bikeid);
			},
			matches(event) {
				const resultList = this.data;
				let matchedResults = [];

				// endyear > years[0]
				// start year < years[1]
				
				if (matchedResults.length == 0) {
					resultList.map((result, index) => {
						if ((parseFloat(result["startyr"]) <= this.years[1]) && parseFloat(result["endyr"]) >= this.years[0]) {
							matchedResults.push(result);
						}
					});
				}
				// for all filters
				this.filters.forEach(item => {
					
					if(!this.filtered[item]) {
						return 
					}

					const bike = this.filtered[item].map(item => item.name);

					if (matchedResults.length == 0) {
						resultList.map((result, index) => {
							if(
								bike.includes(result[item]) && parseFloat(result["startyr"]) != 0 && parseFloat(result["endyr"]) != 0 && 
								(parseFloat(result["startyr"]) <= parseFloat(this.years[1]) && parseFloat(result["endyr"]) >= parseFloat(this.years[0])) ||
								parseFloat(result["startyr"]) <= this.years[1]
							)
							{
								matchedResults.push(result);
							}
						});
					}
					 else {
						matchedResults.forEach((result, index) => {
							if (this.filtered[item]) {
								if (
									(bike.length > 0 && !bike.includes(result[item])) || parseFloat(result["startyr"]) == 0 || parseFloat(result["endyr"]) == 0 || parseFloat(result["startyr"]) > parseFloat(this.years[1]) || parseFloat(result["endyr"]) < parseFloat(this.years[0]) 
									) {
									delete matchedResults[index];
								}
							}
						});
					}
				});

				return matchedResults.filter(Boolean);
			},
			sortedData() {
				let ascDesc = this.sortAsc ? 1 : -1;
				return this.matches.sort((a, b) => {
					// check if the column is a unit column or not
					if (typeof a[this.sortKey] == "string") {
						return (ascDesc * a[this.sortKey].toString().localeCompare(b[this.sortKey].toString()));
					} else {
						return this.unit === "metric" ? ascDesc * a[this.sortKey].metric.toString().localeCompare(b[this.sortKey].metric.toString()) : ascDesc * a[this.sortKey].us.toString().localeCompare(b[this.sortKey].us.toString());
					}
				});
			}
		},
		created() {
			document.title = "Compare Adventure Motorcycle Spec’s";
			document.querySelector('link[rel="canonical"]').href = "https://www.advspecs.com/";
		},
		mounted() {
			EventBus.$on('compare', () => {
				if (this.compareBikes.length < 2) {
					// send error to parent index
					this.error = "Please choose at least two models to compare."
					return;
				}
				// if user input is not filled in then return 0
				for (let [key, value] of Object.entries(this.inputs)) {
					if (value.metric.length == 0) {
						this.inputs[key].metric = 0;
						this.inputs[key].us = 0;
					}
				}
				EventBus.$emit('compareBikes', 
					{
						'bikes': this.selected, 
						'inputs': this.inputs
					}
				);
			});
		},
	};
	
</script>